import { base, darkenColor, lightenColor, offsetColor, ref } from './base';

export const cloudDark = base
  .extend('cloudDark')
  .property('color-scheme', 'dark')
  .property('contrast-direction', 'lighten')

  /**
   * Alerts
   */
  .property('alert.default.background.color', offsetColor('background.color', 5))

  /**
   * Status
   */
  .property('status.success.text.color', 'rgb(220, 252, 231, 0.75)')
  .property('status.warning.text.color', 'rgb(254, 249, 195, 0.75)')
  .property('status.danger.text.color', 'rgb(254, 226, 226, 0.75)')
  .property('status.default.text.color', 'rgb(243, 244, 246, 0.75)')

  .property('status.success.background.color', 'rgb(22, 101, 52, 0.5)')
  .property('status.warning.background.color', 'rgb(113, 63, 18, 0.5)')
  .property('status.danger.background.color', 'rgb(127, 29, 29, 0.5)')
  .property('status.default.background.color', offsetColor('background.color', 8))

  /**
   * Colors
   */
  .property('primary.color', '#0aadff')
  .property('success.color', '#4ec48b')
  .property('warning.color', '#f5c900')
  .property('danger.color', '#f17f7e')
  .property('success.background.color', offsetColor('card.background.color', 5))
  .property('warning.background.color', offsetColor('card.background.color', 5))
  .property('danger.background.color', offsetColor('card.background.color', 5))
  .property('background.color', '#22272e')
  .property('text.color', '#adbac7')
  .property('text.muted.color', darkenColor('text.color', 25))

  /**
   * Header
   */
  .property('header.background.color', offsetColor('background.color', 3))

  /**
   * Bubble
   */
  .property('bubble.background.color', offsetColor('background.color', 5))
  .property('bubble.border.color', offsetColor('background.color', 10))

  /**
   * Billing
   */
  .property('invoice.status.paid.text.color', 'rgb(220, 252, 231, 0.75)')
  .property('invoice.status.due.text.color', 'rgb(254, 249, 195, 0.75)')
  .property('invoice.status.overdue.text.color', 'rgb(255, 237, 213, 0.75)')
  .property('invoice.status.failed.text.color', 'rgb(254, 226, 226, 0.75)')
  .property('invoice.status.void.text.color', 'rgb(243, 244, 246, 0.75)')

  .property('invoice.status.paid.background.color', 'rgb(22, 101, 52, 0.5)')
  .property('invoice.status.due.background.color', 'rgb(113, 63, 18, 0.5)')
  .property('invoice.status.overdue.background.color', 'rgb(124, 45, 18, 0.5)')
  .property('invoice.status.failed.background.color', 'rgb(127, 29, 29, 0.5)')
  .property('invoice.status.void.background.color', 'rgb(17, 24, 39, 0.5)')

  .property('invoice.status.paid.border.color', ref('invoice.status.paid.background.color'))
  .property('invoice.status.due.border.color', ref('invoice.status.due.background.color'))
  .property('invoice.status.overdue.border.color', ref('invoice.status.overdue.background.color'))
  .property('invoice.status.failed.border.color', ref('invoice.status.failed.background.color'))
  .property('invoice.status.void.border.color', ref('invoice.status.void.background.color'))

  /**
   * Chat
   */
  .property('chat.message.rich.tag.background.color', 'transparent')
  .property('chat.message.rich.tag.border.color', ref('primary.color'))
  .property('chat.message.rich.tag.text.color', ref('primary.color'))

  .property(
    'invoice.status.paid.border.color',
    darkenColor('invoice.status.paid.background.color', 5),
  )
  .property(
    'invoice.status.due.border.color',
    darkenColor('invoice.status.due.background.color', 5),
  )
  .property(
    'invoice.status.overdue.border.color',
    darkenColor('invoice.status.overdue.background.color', 5),
  )
  .property(
    'invoice.status.failed.border.color',
    darkenColor('invoice.status.failed.background.color', 5),
  )
  .property(
    'invoice.status.void.border.color',
    darkenColor('invoice.status.void.background.color', 5),
  )

  /**
   * Nudge
   */
  .property('nudge.background.color', '#fff')
  .property('nudge.text.color', '#2c2d2d')
  .property('nudge.completion.bar.color', ref('primary.color'))
  .property('nudge.error.background.color', 'rgb(48, 8, 8)')
  .property('nudge.error.text.color', 'rgb(254, 202, 202)')
  .property('nudge.error.completion.bar.color', 'rgb(100, 28, 28)')

  /**
   * Campaign
   */
  .property('campaign.status.scheduled.background.color', 'rgba(91, 33, 182, 0.2)')
  .property('campaign.status.scheduled.text.color', 'rgba(237, 233, 254, 0.85)')
  .property(
    'campaign.status.scheduled.border.color',
    lightenColor('campaign.status.scheduled.background.color', 8),
  )

  .property('campaign.status.sending.background.color', offsetColor('card.background.color', 5))
  .property('campaign.status.sending.text.color', 'rgba(219, 234, 254, 0.9)')
  .property(
    'campaign.status.sending.border.color',
    darkenColor('campaign.status.sending.background.color', 5),
  )

  /**
   * Workflow
   */
  .property('workflow.overdue.background.color', 'rgb(127, 29, 29, 0.5)')

  /**
   * Select Options
   */
  .property('select.option.text.color', ref('text.color'))
  .property('select.option.background.color', offsetColor('background.color', 5))
  .property('select.option.checked.background.color', ref('primary.color'))
  .property('select.option.checked.text.color', '#fff');
